import { IDonor } from "../donor";
import { IRecipient } from "../recipient";
import { IDonorPreselect } from './donor-preselect';

export interface IOneWay {
    id: number
    hlaMatchScore: number,
    donorPmpScore: number,
    recipientPmpScore: number,
    isPreselectAccepted: boolean,
    recipientWaitTime: number
    donorAbo: string,
    recipientAbo: string,
    exmDisplayString: string,
    onlyDonorIdMatchC: number,
    ssdRecipientCount: number,
    ssdRecipientList: number[],
    ssdHtml: string,
    donor: IDonor,
    recipient: IRecipient,
    donorPreselect: IDonorPreselect,
    distanceBetweenCenters: number,
    bmtMm: number
}